import React from 'react';

import styles from './SpecialGeo.css';

interface ISpecialGeoProps {
  label: string;
  icon: React.ReactNode;
  remoteness?: React.ReactNode;
}

export function SpecialGeo({ icon, label, remoteness }: ISpecialGeoProps) {
  return (
    <div className={styles['container']}>
      <span className={styles['content']}>
        <div className={styles['icon']}>{icon}</div>
        <div className={styles['name']}>{label}</div>
      </span>
      {remoteness && <div className={styles['remoteness']}>{remoteness}</div>}
    </div>
  );
}
